import { render, staticRenderFns } from "./new-site-form.vue?vue&type=template&id=51ea3106&"
import script from "./new-site-form.vue?vue&type=script&lang=js&"
export * from "./new-site-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports